// @ts-nocheck
import React, { useEffect, useState } from 'react';

const steps = [
  {
    id: 'paste',
    title: 'Paste a link',
    body: 'Copy a reel/short/TikTok URL and tap the Paste button.',
  },
  {
    id: 'enrich',
    title: 'We enrich the place',
    body: 'We extract the place and pull photos & ratings to help you decide.',
  },
  {
    id: 'directions',
    title: 'Tap card for directions',
    body: 'Open the place in Maps or start navigation right from the card.',
  },
];

export default function OnboardingCoach({
  suppress = false,
}: { suppress?: boolean }) {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    // show once per browser until dismissed
    const seen = localStorage.getItem('fs_seen_onboarding');
    if (!seen) setOpen(true);
  }, []);

  const close = () => {
    setOpen(false);
    localStorage.setItem('fs_seen_onboarding', '1');
  };

  if (!open || suppress) return null;
  const step = steps[index];

  return (
    <div className="fixed inset-0 z-[100]">
      <div className="absolute inset-0 bg-black/50" onClick={close} />

      <div className="absolute inset-0 pointer-events-none">
        {/* Simple spotlight ring near bottom-right where Paste FAB typically lives */}
        {index === 0 && (
          <div className="absolute bottom-20 right-6 w-32 h-32 rounded-full ring-4 ring-blue-400/60 bg-blue-400/5 pointer-events-none animate-pulse" />
        )}
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 w-[min(560px,calc(100%-24px))] pointer-events-auto">
        <div className="rounded-2xl bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 shadow-xl p-4">
          <div className="flex items-start justify-between gap-4">
            <div className="min-w-0">
              <div className="text-sm font-semibold">{step.title}</div>
              <div className="text-sm text-gray-600 dark:text-gray-300">{step.body}</div>
            </div>
            <button onClick={close} aria-label="Dismiss" className="p-2 rounded hover:bg-gray-100 dark:hover:bg-gray-800">✕</button>
          </div>
          <div className="mt-3 flex items-center justify-between">
            <div className="flex gap-1">
              {steps.map((_, i) => (
                <span key={i} className={`h-1.5 rounded-full transition-all ${i===index?'w-6 bg-blue-600':'w-3 bg-gray-300 dark:bg-gray-700'}`} />
              ))}
            </div>
            <div className="flex gap-2">
              {index > 0 && (
                <button onClick={()=>setIndex(i=>Math.max(0,i-1))} className="px-3 py-1.5 text-sm rounded border border-gray-300 dark:border-gray-700">Back</button>
              )}
              {index < steps.length - 1 ? (
                <button onClick={()=>setIndex(i=>Math.min(steps.length-1,i+1))} className="px-3 py-1.5 text-sm rounded bg-blue-600 text-white">Next</button>
              ) : (
                <button onClick={close} className="px-3 py-1.5 text-sm rounded bg-blue-600 text-white">Got it</button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
